/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import Head from "../Global/Head";
import Header from "../Global/Header";
import SkellitonCard from "../shared/skellitonCard/SkellitonCard";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BookmarkCard from "../shared/concertCard/BookmarkCard";
import Footer from "../shared/footer/Footer";
import { use } from "react";

const SearchResultPage = () => {
  const location = useLocation();
  const { data, error, details, searchPayload } = location.state || {};
  const { address, from, to, search } = searchPayload || {};
  const navigate = useNavigate();

  const handleNavigate = (name, id) => {
    const formattedName = name.replace(/\s+/g, "-"); // Replace spaces with dashes
    navigate(`/details?table=${encodeURIComponent(formattedName)}&id=${id}`);
  };

  useEffect(() => {
    if (!data) {
      navigate("/");
    }
  }, []);

  const [isVisible, setIsVisible] = useState(false);

  return (
    <div>
      <Link to={"/mobileSearch"} className="sm:hidden stickynav-custom">
        <div style={{ pointerEvents: "none" }}>
          <Head />
          <Header setIsVisible={setIsVisible} />
        </div>
      </Link>
      <div className="hidden sm:inline">
        <Head />
        <Header />
      </div>
      <section className="">
        <div
          data-current="Tab 1"
          data-easing="ease-in-out"
          data-duration-in="300"
          data-duration-out="300"
          className="tabs-2 w-tabs"
        >
          <div className="tabs-content-wrapper w-tab-content">
            <div
              data-w-tab="Tab 1"
              className="tab-content-item w-tab-pane w--tab-active"
            >
              {error ? (
                <div>
                  <h2>Error: {error}</h2>
                  {details && <pre>{JSON.stringify(details, null, 2)}</pre>}
                </div>
              ) : (
                <div>
                  {data?.items.length > 0 && (
                    <div className="text-base mx-[24px] text-gray-700 font- flex items-center gap-3">
                      <div>
                        Tables
                        {address && ` near ${address}`}
                        {from && to && ` from ${from} to ${to}`}
                        {search && ` for ${search}`}
                      </div>
                    </div>
                  )}

                  <div className="tab-content">
                    <section className="category-tab">
                      <div
                        data-current="Tab 1"
                        data-easing="ease-in-out"
                        data-duration-in="300"
                        data-duration-out="300"
                        className="tabs-2 w-tabs"
                      >
                        {data?.items <= 0 && (
                          <>
                            <div className="text-center text-xl h-56 text-gray-400 mt-16 flex flex-col items-center">
                              <img
                                className="h-20 w-20 items-center"
                                src="	https://cdn-icons-png.freepik.com/512/6146/6146689.png?ga=GA1.1.1598467923.1731688846"
                              />
                              Whoops! We searched high and low but found
                              nothing. Try tweaking your search!
                            </div>
                          </>
                        )}
                        <div className="w-layout-grid table-category-grid  ">
                          {data?.items.map((card, index) => (
                            <div
                              key={index}
                              onClick={() =>
                                handleNavigate(card?.title, card.id)
                              }
                            >
                              <BookmarkCard
                                slide={card}
                                creator_profile_id={card.user_profile}
                              />
                            </div>
                          ))}
                        </div>
                        {/* {data.items.length <= 0 ? (
                          <>
                            <div className="tab-content">
                              <div className="w-layout-grid table-category-grid ">
                                {Array.from({ length: limit }, (_, index) => (
                                  <SkellitonCard key={index} />
                                ))}
                              </div>
                            </div>
                          </>
                        ) : null} */}
                      </div>
                    </section>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default SearchResultPage;
